<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      {{ titleHero }}
    </hero-bar>
    <section class="section is-main-section">
      <customer-reminder></customer-reminder>
    </section>
  </div>
</template>

<script>
import CustomerReminder from "@/components/Customers/CustomerReminder";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import router from "../../router/index";

export default {
  name: "CustomersAddView",
  components: { HeroBar, TitleBar, CustomerReminder },
  data() {
    return {
      isModalActive: false,
      id: this.$route.params.id,
      url: window.location.href
    };
  },
  computed: {
    titleHero() {
      return "Customer Reminders";
    },
    titleStack() {
      return [
        { url: "/customers", name: "Customer Profile" },
        { url: "/dashboard/", name: " Dashboard" }
      ];
    }
  },
  methods: {
    backBtnAction() {
      router.go(-1);
    }
  }
};
</script>
